import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {UserState} from '@local/redux/state/user';

const initialState: UserState = {};
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<UserState>) => {
      return action.payload;
    },
    clear: () => initialState,
  },
});
export const userReducer = userSlice.reducer;
export const userActions = userSlice.actions;
